import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../../misc/constants";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import { GeneralProceduresCricPart2Config, GeneralProceduresCricMainConfig } from "../GeneralProceduresCricMain";

var alreadyAdded = false;
export default class GeneralProceduresCricPart2 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralProceduresCricPart2Config {
		return this.scenarioConfig.part2Config;
	}
	constructor(private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralProceduresCricMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.step1IdentifyLandmarksVideo();
	}

	public step1IdentifyLandmarksVideo() {
		const context = this;
		context.playVideoChapter(context.config.identifyLandmarksVideoChapter(), () => {
			if(this.config.areLandmarksObstructed) {
				context.scenario.uiWrapper.displayGeneralAlertUI({
					title: this.config.landmarksObstructedMessageTitle ?? 'Landmarks Covered',
					text: this.config.landmarksObstructedMessageText ?? 'All landmarks are covered by the jaw.',
					okButton: {
						title: 'OK',
						onClicked: () => {
							context.onDone();
						}
					}
				});
			} else {
				context.step2IdentifyLandmarksUI();
			}
		})
	}

	public step2IdentifyLandmarksUI() {
		const context = this;
		context.scenario.uiWrapper.displayPalpitateNeckUI({
			isDebug: true,
			incorrectMessages: context.config.identifyLandmarksIncorrectMessages,
			onFailed: () => {
                context.scenario.failedScenario = true;
				context.scenario.onShowSuccessFailedAttempt(constants.attemptText.failedTitle, context.config.identifyLandmarksFailedMessage ?? 'You failed to properly identify the vital landmarks required.', true, () => {
					
				});
			},
			onSingleLandmarkSelected: (isCorrect: boolean) => {
				if(context.config.onSingleLandmarkSelected) {
					context.config.onSingleLandmarkSelected(isCorrect);
				}
			},
			onFinished: (isCorrect: boolean) => {
				if(!isCorrect) {
					context._scenario.arrangeCricToolsPoints = 100;
				}

				if(context.config.onLandmarksFinished) {
					context.config.onLandmarksFinished(isCorrect);
				}
				if(context.scenarioConfig.isCricScenario && !alreadyAdded) {
					context._scenario.addScore(context.scenario.arrangeCricToolsPoints);
					alreadyAdded = true;
				}
				context.onDone();
			}
		});

	}
}